import React, {useEffect, useState} from 'react';
import { Line } from 'react-chartjs-2';  // Import wykresu liniowego
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Input, InputContainer, ChartContainer, Label, RowForm, OptionsForm, ParametersText, ContentContainer, DefaultValueButton, InputCheckboxElement, InputRadioButton } from './WilkOwcaElements';
import {InputLimitAndEmptyValueHandling} from "../../scripts/InputHandling";

// Rejestracja komponentów Chart.js (wymagane dla react-chartjs-2)
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);



const WilkiOwcaPage = () => {
    const [inputs, setInputs] = useState({sheep_start: 20, days: 10, wolf_start: 20, alpha: 0.5, beta: 0.02, delta: 0.01, gamma: 0.8, DisplayOptions: false});
    const [sheep, setSheep] = useState([]);
    const [wolf, setWolf] = useState([]);
    const InputsLimit = [
        {
            InputName: "sheep_start",
            LimitMax: null,
            LimitMin: 5,
            default: 20
        },
        {
            InputName: "days",
            LimitMax: null,
            LimitMin: 5,
            default: 10
        },
        {
            InputName: "wolf_start",
            LimitMax: null,
            LimitMin: 2,
            default: 20
        },
        {
            InputName: "alpha",
            LimitMax: null,
            LimitMin: 0,
            default: 0.5
        },
        {
            InputName: "beta",
            LimitMax: null,
            LimitMin: 0,
            default: 0.02
        },
        {
            InputName: "delta",
            LimitMax: null,
            LimitMin: 0,
            default: 0.01
        },
        {
            InputName: "gamma",
            LimitMax: null,
            LimitMin: 0,
            default: 0.8
        }];
    function lotkaVolterra(initialPrey, initialPredators, days, alpha = 0.5, beta = 0.02, gamma = 0.8, delta = 0.01) {
        const dt = 0.01;
        let prey = initialPrey;
        let predators = initialPredators;
        const results = [];

        results.push({ day: 0, prey: Math.round(prey), predators: Math.round(predators)});

        for (let day = 1; day <= days; day++) {
            let time = 0;
            while (time < 1) {
                const dPrey = (alpha * prey - beta * prey * predators) * dt;
                const dPredators = ((-gamma * predators) + (delta * prey * predators)) * dt;


                prey += dPrey;
                predators += dPredators;


                if (prey < 1) prey = 0;
                if (predators < 1) predators = 0;

                time += dt;
            }


            results.push({
                day: day,
                prey: Math.round(prey),
                predators: Math.round(predators)
            });
        }
        return results;
    }
    //const simulation = lotkaVolterra(100, 10, 50);  // 100 ofiar, 10 drapieżników, 50 dni
    //console.log(simulation);

    const handleChange = (e) =>{
        setInputs({...inputs, [e.target.name]: e.target.checked});
    }
    const handleOutFocus = (e) => {
        const properValue = InputLimitAndEmptyValueHandling(InputsLimit, e)
        setInputs({...inputs, [e.target.name]: properValue});
        e.target.value = properValue;
    }

    useEffect(() => {
        const sim = lotkaVolterra(inputs.sheep_start, inputs.wolf_start, inputs.days, inputs.alpha, inputs.beta, inputs.gamma, inputs.delta);
        setSheep(sim.map(s => s.prey));
        setWolf(sim.map(s => s.predators));
    },[inputs])

    const defaultvalue = () => {
        setInputs(
            {
                ...inputs,
                alpha: 0.5,
                beta: 0.02,
                gamma: 0.8,
                delta: 0.01,
            });
    }
    //let sheep = [inputs.sheep_start,2,3,6,7,8,9,4,23];
    //const wolf = [inputs.wolf_start,6,5,8,4,7,6,4,65];
    let data = {
        labels: Array.from({ length: inputs.days+1 }, (value, index) => (index===0) ? "Punkt startowy" : "Dzień "+index),  // Etykiety osi X
        datasets: [
            {
                label: 'Wilki',  // Legenda
                data: wolf,  // Dane osi Y
                borderColor: 'rgba(75, 192, 192, 1)',  // Kolor linii
                backgroundColor: 'rgba(75, 192, 192, 0.2)',  // Kolor tła
                tension: 0.1,  // Gładkość linii
            },
            {
              label: 'Owce',
              data: sheep,
              borderColor: 'rgb(75,192,85)',
              backgroundColor: 'rgba(75,192,102,0.2)',
              tension: 0.1,
            },
        ],
    };

    // Opcje wykresu (opcjonalne)
    const options = {
        responsive: true,  // Responsywność
        plugins: {
            legend: {
                position: 'top',  // Pozycja legendy
            },
        },
    };
    return (
        <>
            <h1>Model Lotki-Volterry</h1>
            <ContentContainer>
                <InputContainer>
                    <RowForm>
                    <Label htmlFor="sheep-input">Wprowadź liczbę początkową ofiar:</Label>
                    <Input id="sheep-input" name="sheep_start" type="number" defaultValue={inputs.sheep_start} onBlur={handleOutFocus} min="5"/>
                    </RowForm>
                    <RowForm>
                    <Label htmlFor="wolf-input">Wprowadź liczbę początkową drapieżników:</Label>
                    <Input id="wolf-input" name="wolf_start" type="number" defaultValue={inputs.wolf_start} onBlur={handleOutFocus} min="2"/>
                    </RowForm>
                    <RowForm>
                    <Label htmlFor="days-input">Wprowadź liczbę dni symulacji:</Label>
                    <Input id="days-input" name="days" type="number" defaultValue={inputs.days} onBlur={handleOutFocus} min="5"/>
                    </RowForm>
                    <ParametersText>Parametry modelu</ParametersText>
                    <RowForm>
                        <Label htmlFor="alpha-input">Wprowadź wartość alpha:</Label>
                        <Input id="alpha-input" name="alpha" type="number" defaultValue={inputs.alpha} onBlur={handleOutFocus} min="0" step="0.01"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="beta-input">Wprowadź wartość beta:</Label>
                        <Input id="beta-input" name="beta" type="number" defaultValue={inputs.beta} onBlur={handleOutFocus} min="0" step="0.01"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="delta-input">Wprowadź wartość delta:</Label>
                        <Input id="delta-input" name="delta" type="number" defaultValue={inputs.delta} onBlur={handleOutFocus} min="0" step="0.01"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="gamma-input">Wprowadź wartość gamma:</Label>
                        <Input id="gamma-input" name="gamma" type="number" defaultValue={inputs.gamma} onBlur={handleOutFocus} min="0" step="0.01"/>
                    </RowForm>
                    <RowForm>
                        <DefaultValueButton onClick={defaultvalue}>Przywróć wartości domyślne</DefaultValueButton>
                    </RowForm><br/>
                    <RowForm>
                        <Label  htmlFor="Display-input"></Label>
                        <InputCheckboxElement id="Display-input" name="DisplayOptions" type="checkbox" checked={inputs.DisplayOptions} onChange={handleChange}/>
                    </RowForm>
                    <OptionsForm display_options={inputs.DisplayOptions.toString()}>
                        <RowForm>
                            <Label htmlFor="Model1">Model podstawowy</Label>
                            <InputRadioButton id="Model1" type="radio" name="model"/>
                        </RowForm>
                        <RowForm>
                            <Label htmlFor="Model2">Model rozszerzony</Label>
                            <InputRadioButton id="Model2" type="radio" name="model"/>
                        </RowForm>
                    </OptionsForm>
                </InputContainer>
                <ChartContainer>
                    <Line data={data} options={options} />
                </ChartContainer>
            </ContentContainer>
        </>
    )
}

export default WilkiOwcaPage
